export const rvSectionHasChanged = (initialValues, values) => {
  const QuestionsAreUpdated = checkIfRvQuestionsWereUpdated(initialValues, values);
  const productsAreUpdated = checkIfRvProductsWereUpdated(initialValues, values);

  return QuestionsAreUpdated || productsAreUpdated;
};

const checkIfRvQuestionsWereUpdated = (initialValues, values) => {
  if (initialValues.rvQuestions.length !== values.rvQuestions.length) {
    return true;
  }
  for (let [index, initialQuestion] of initialValues.rvQuestions.entries()) {
    const newQuestion = values.rvQuestions[index];
    const questionWasUpdated = checkIfQuestionFieldsWereUpdated(initialQuestion, newQuestion);

    if (questionWasUpdated) {
      return true;
    }
  }
  return false;
};

const checkIfQuestionFieldsWereUpdated = (initialQuestion, newQuestion) => {
  const listOrderIsUpdated = initialQuestion.listOrder !== newQuestion.listOrder;
  const maxLengthIsUpdated = initialQuestion.maxLength !== newQuestion.maxLength;
  const minLengthIsUpdated = initialQuestion.minLength !== newQuestion.minLength;
  const questionIsUpdated = initialQuestion.question !== newQuestion.question;
  const questionTypeIsUpdated = initialQuestion.questionType !== newQuestion.questionType;
  const requiredIsUpdated = initialQuestion.required !== newQuestion.required;
  const savedIsUpdated = initialQuestion.saved !== newQuestion.saved;
  const answersWereUpdated = checkIfAnswersWereUpdated(initialQuestion, newQuestion);

  return (
    listOrderIsUpdated ||
    maxLengthIsUpdated ||
    minLengthIsUpdated ||
    questionIsUpdated ||
    questionTypeIsUpdated ||
    requiredIsUpdated ||
    answersWereUpdated ||
    savedIsUpdated
  );
};

const checkIfAnswersWereUpdated = (initialQuestion, newQuestion) => {
  if (initialQuestion.answerOptions.length !== newQuestion.answerOptions.length) {
    return true;
  }
  for (let [index, initialAnswer] of initialQuestion.answerOptions.entries()) {
    const newAnswer = newQuestion.answerOptions[index];
    if (initialAnswer.text !== newAnswer.text) {
      return true;
    }
  }
  return false;
};

const checkIfRvProductsWereUpdated = (initialValues, values) => {
  if (initialValues.rvs.length !== values.rvs.length) {
    return true;
  }
  for (let [index, initialRvProduct] of initialValues.rvs.entries()) {
    const newRvProduct = values.rvs[index];
    const rvProductWasUpdated = checkIfRvProductFieldsWereUpdated(initialRvProduct, newRvProduct);

    if (rvProductWasUpdated) {
      return true;
    }
  }
  return false;
};

const checkIfRvProductFieldsWereUpdated = (initialRvProduct, currentRvProduct) => {
  const rvLotIdIsUpdated = initialRvProduct.rvLotId !== currentRvProduct.rvLotId;
  const minNightsIsUpdated = +initialRvProduct.minNights !== +currentRvProduct.minNights;
  const startDateIsUpdated = initialRvProduct.dateRange.startDate !== currentRvProduct.dateRange.startDate;
  const endDateIsUpdated = initialRvProduct.dateRange.endDate !== currentRvProduct.dateRange.endDate;
  const pricingIsUpdated = initialRvProduct.pricing !== currentRvProduct.pricing;
  const priceIsUpdated = +initialRvProduct.price !== +currentRvProduct.price;
  const flipIsUpdated = initialRvProduct.flippingDisabled !== currentRvProduct.flippingDisabled;
  const spotsAreUpdated = checkIfSpotsWereUpdated(initialRvProduct, currentRvProduct);

  return (
    rvLotIdIsUpdated || minNightsIsUpdated || startDateIsUpdated || endDateIsUpdated || pricingIsUpdated || priceIsUpdated || flipIsUpdated || spotsAreUpdated
  );
};

const checkIfSpotsWereUpdated = (initialRvProduct, currentRvProduct) => {
  if (initialRvProduct.spots.length !== currentRvProduct.spots.length) {
    return true;
  }
  const initialSpots = new Map(initialRvProduct.spots.map(spot => [spot, spot]));
  const currentSpots = new Map(currentRvProduct.spots.map(spot => [spot, spot]));
  const spotsWereRemoved = checkIfSpotsWereRemoved(initialSpots, currentSpots);
  const spotsWereAdded = checkIfSpotsWereAdded(initialSpots, currentSpots);

  return spotsWereRemoved || spotsWereAdded;
};

const checkIfSpotsWereRemoved = (initialSpots, currentSpots) => {
  for (let initialSpot of initialSpots.keys()) {
    if (!currentSpots.has(initialSpot)) {
      return true;
    }
  }
  return false;
};

const checkIfSpotsWereAdded = (initialSpots, currentSpots) => {
  for (let currentSpot of currentSpots.keys()) {
    if (!initialSpots.has(currentSpot)) {
      return true;
    }
  }
  return false;
};
